module.exports = __webpack_public_path__ + "static/media/transporter-2.34dfee8e.svg";